import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import { Menu, X } from "lucide-react";

export default function Navbar({ currentPage, setCurrentPage, onOrderNow }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("Home");

  const navLinks = [
    { label: "Home", page: "home" },
    { label: "Our Operators", page: "home", anchor: "operators" },
    { label: "How It Works", page: "home", anchor: "how-it-works" },
    { label: "Track Order", page: "track" },
    { label: "Contact", page: "contact" },
  ];

  useEffect(() => {
    if (currentPage !== "home") {
      const currentLink = navLinks.find((link) => link.page === currentPage && !link.anchor);
      if (currentLink) setActiveLink(currentLink.label);
    }
  }, [currentPage]);

  function handleNavClick(page, anchor, label) {
    setActiveLink(label);
    if (page) setCurrentPage(page);
    if (anchor) {
      setTimeout(() => {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setMobileOpen(false);
  }

  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-xl bg-white/70 border-b border-slate-200/60 shadow-xs">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between rounded-full border border-white/80 bg-white/60 px-4 py-2 shadow-lg shadow-slate-900/5 backdrop-blur-2xl">
          
          {/* Logo */}
<button
  type="button"
  onClick={() => handleNavClick("home")}
  className="flex items-center gap-2 rounded-full p-1 transition-transform hover:scale-[1.01] focus:outline-none"
>
  {/* Yahan purane A1 icon div ki jagah apni image lagayein */}
  <img 
    src={logo} 
    alt="A1 Sims Logo" 
    className="h-12 pl-6 w-auto object-contain" 
  />
</button>

          {/* Desktop Nav Links */}
          <nav className="hidden items-center gap-1 rounded-full border border-slate-200/60 bg-slate-100/60 p-1 md:flex">
            {navLinks.map((link) => {
              const isActive = activeLink === link.label;
              return (
                <button
                  type="button"
                  key={link.label}
                  onClick={() => handleNavClick(link.page, link.anchor, link.label)}
                  className={`rounded-full px-4 py-2 text-sm font-semibold transition-all ${
                    isActive
                      ? "bg-blue-900 text-white shadow-sm"
                      : "text-slate-700 hover:text-orange-600 hover:bg-white/80"
                  }`}
                >
                  {link.label}
                </button>
              );
            })}
          </nav>

          {/* CTA & Mobile Button */}
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onOrderNow}
              className="hidden sm:flex bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold text-sm px-6 py-2.5 rounded-full shadow-md shadow-orange-500/25 transition-all"
            >
              Order Now
            </button>
            <button
              type="button"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white/70 text-slate-700 md:hidden"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="mx-4 mt-2 rounded-2xl border border-white/80 bg-white/70 p-3 shadow-xl backdrop-blur-2xl md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                type="button"
                key={link.label}
                onClick={() => handleNavClick(link.page, link.anchor, link.label)}
                className={`rounded-xl px-3.5 py-2.5 text-left text-sm font-semibold transition-colors ${
                  activeLink === link.label
                    ? "bg-blue-900 text-white shadow-sm"
                    : "text-slate-700 hover:bg-white/70"
                }`}
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => {
                onOrderNow();
                setMobileOpen(false);
              }}
              className="mt-2 w-full rounded-full bg-gradient-to-r from-orange-500 to-orange-600 py-3 text-white font-bold text-sm shadow-md"
            >
              Order Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}